import {
  Integration_Handler_Names_Enum,
  Integration_Names_Enum,
  Integration_Service_Names_Enum,
} from '@main/graphql/types.generated';
import {
  forwardRef,
  ForwardRefExoticComponent,
  ForwardRefRenderFunction,
  RefAttributes,
} from 'react';

export type ConfigComponentType = ForwardRefExoticComponent<ConfigProps & RefAttributes<ConfigRef>>;

export const configForwardRef = <TConfig>(
  render: ForwardRefRenderFunction<ConfigRef<TConfig>, ConfigProps<TConfig>>,
) => {
  return forwardRef(render) as ConfigComponentType;
};

export type ConfigRef<TConfig = unknown> = {
  submit: () => Promise<TConfig | undefined>;
  delete?: () => Promise<void>;
  reset?: () => void;
};

export type AnyConfigRef = {
  submit: () => Promise<Record<string, unknown> | undefined>;
  delete?: () => Promise<void>;
  reset?: () => void;
};

export type ConfigProps<TConfig = unknown> = {
  orgIntegrationId: string;
  providerName: Integration_Names_Enum;
  serviceName?: Integration_Service_Names_Enum;
  handlerName?: Integration_Handler_Names_Enum;
  evidenceConfig?: TConfig;
  isSubmitting?: boolean;
  isDisabled?: boolean;
  onDirtyChange?: (isDirty: boolean) => void;
};
